export const msalConfig = {
  auth: {
    // นำ Application (client) ID จาก Azure มาใส่ตรงนี้
    //clientId: '9c0cc0e2-0252-4d6c-83da-9bcaf7990b76',
    clientId: '2519d5ea-d3d5-4755-9773-52b243648735',
    // นำ Directory (tenant) ID มาต่อท้าย URL (หรือใช้ common ถ้าให้เมล์ทั่วไปล็อกอินได้)
        //authority: "https://login.microsoftonline.com/common", 
         authority: "https://login.microsoftonline.com/4f1490cf-1ef9-45d6-bee0-e2358880ebcb", 
    // หน้าเว็บที่ให้เด้งกลับมาหลังจากล็อกอินเสร็จ
        redirectUri: window.location.origin 
    },
    cache: {
        cacheLocation: "sessionStorage", 
        storeAuthStateInCookie: false, 
    }
};

// สิทธิ์ที่เราต้องการขอ (แค่โปรไฟล์พื้นฐาน)
export const loginRequest = {
    scopes: ["User.Read"],
    prompt: "select_account"
};